import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const Laboureres = lazy(() => import('../modules/admin/laboureres/index'));

const LaboureresTable = lazy(
  () => import('../modules/admin/laboureres/pages/LaboureresTable')
);

const LaboureresRoutes = (
  <>
    <Route
      path="labourers"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Laboureres />
        </Suspense>
      }
    >
      <Route
        index
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.LABOURS_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <LaboureresTable />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default LaboureresRoutes;
